// @flow
import './AutocompleteTextBox.css';

import * as React from 'react';
import Portal from './../../common/Portal';
import _ from 'lodash';
import Button from '../Button';
import TextBox from './TextBox';
import SearchUtil from '../../util/SearchUtil';
import { FilesResponseData } from '../../autogenerated/ZoomBridge';
import { KeyCode } from '../../util/Constants';

const debug = require('../../debug/debug')('wc:common:form:AutocompleteTextBox');

type Props = {
  value: string,
  onChange: Function,
  className?: string,
  clearable?: boolean,
  size?: string,
  data?: Object[]
};

type State = {
  showList: boolean
};

export default class AutocompleteTextBox extends React.Component<Props, State> {
  static defaultProps = {};

  _textbox: ?TextBox;

  state = {
    showList: false
  };

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.value && !nextProps.data && nextProps.value !== this.props.value) {
      this.fetchData(nextProps.value);
    }
  }

  fetchData = _.debounce(async (searchString: string) => {
    try {
      debug('[fetchData()] calling SearchUtil.searchQuery() with value: ', searchString);
      const res: FilesResponseData = await SearchUtil.searchQuery(searchString);
    } catch (err) {
      debug('[fetchData()] error: ', err);
    }
  }, 1000);

  onFocus = () => {
    this.setState({ showList: true });
  };

  onBlur = () => {
    this.setState({ showList: false });
  };

  onKeyDown = (e: KeyboardEvent) => {
    if (e.keyCode === KeyCode.ENTER) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  renderList = () => {
    const { showList } = this.state;
    if (!showList) {
      return null;
    }

    const rect = this._textbox ? this._textbox.node.getBoundingClientRect() : {};
    const style = {
      top: rect.bottom,
      left: rect.left,
      background: 'var(--primary-header-bg)'
    };

    return (
      <Portal defaultOpen={true} closeOnEsc={true} closeOnOutsideClick={true} onClose={this.onBlur}>
        <div name="AutocompleteTextBox_Portal" style={style}>
          hi
        </div>
      </Portal>
    );
  };

  render() {
    const { data, ...rest } = this.props;
    return (
      <div name="AutocompleteTextBox">
        <TextBox
          {...rest}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onKeyDown={this.onKeyDown}
          ref={(inst) => (this._textbox = inst)}
        />
      </div>
    );
  }
}
